import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}
export function CTAButton({
  children,
  onClick,
  className = ''
}: CTAButtonProps) {
  return <motion.button whileHover={{
    scale: 1.02,
    y: -2
  }} whileTap={{
    scale: 0.98
  }} onClick={() => {
    if (onClick) {
      onClick();
    } else {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'AddToCart', {
          content_name: 'Guía Anti-Inflamatoria 14 Días',
          content_type: 'product',
          value: 6.39,
          currency: 'USD'
        });
      }
      window.open('https://www.renaceractivo.com/cart/45892639785121:1', '_blank');
    }
  }} className={`bg-brand-terracotta hover:bg-brand-amber text-white font-semibold py-4 px-8 rounded-full shadow-lg transition-colors text-xl w-full sm:w-auto ${className}`} data-id="element-160">
      {children}
    </motion.button>;
}